import React from "react";
import BadgesTile from "../../components/UI/BadgesTile";


function Badges() {

  return (
    <div className="container">
      <BadgesTile />
    </div>
  )
}



export default Badges;